import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";

import grey from "@material-ui/core/colors/grey";
import { green, red, yellow } from "@material-ui/core/colors";
import Grid from "@material-ui/core/Grid";
import ConfirmButton from "../../components/ConfirmButton";

const useStyles = makeStyles(theme => ({
  itemContent: {
    height: "auto",
    borderBottom: "solid",
    borderBottomColor: grey[200],
    backgroundColor: "white",
  },

  listItemText: {
    textTransform: "none",
  },

  contentTitle: {
    fontSize: "2.00rem",
    fontWeight: "bold",
    marginBottom: theme.spacing(4),
  },

  labelAndValue: {
    "& label": {
      fontWeight: "bold",
      paddingRight: theme.spacing(2),
    },
  },

  active: {
    textTransform: "uppercase",
    color: green[500],
  },

  inactive: {
    textTransform: "uppercase",
    color: red[500],
  },

  restricted: {
    textTransform: "uppercase",
    color: yellow[500],
  },

  actionContainer: {
    "& button": {
      margin: "10px 0",
    },
  },
}));

const IpOverrideListItem = ({
  override,
  selected,
  onSelect,
  onDeleteClick,
}) => {
  const classes = useStyles();

  return (
    <ListItem
      selected={selected}
      autoFocus={selected}
      classes={{ root: classes.itemContent }}
      key={override.regionIpOverrideId}
      onClick={() => onSelect(override)}
    >
      <ListItemText
        classes={{ root: classes.listItemText }}
        disableTypography={true}
        primary={
          <React.Fragment>
            <div className={classes.contentTitle}>
              {override.ipAddressAsString}
            </div>
          </React.Fragment>
        }
        secondary={
          <Grid container justify="flex-start" spacing={2}>
            <Grid item sm={5}>
              <div className={classes.labelAndValue}>
                <label>Id:</label>
                {override.regionIpOverrideId}
              </div>
            </Grid>

            <Grid item sm={3}>
              <Grid container direction="column" spacing={1}>
                {override.region.city && (
                  <Grid item>
                    <div className={classes.labelAndValue}>
                      <label>City:</label>
                      {override.region.city}
                    </div>
                  </Grid>
                )}

                {override.region.county && (
                  <Grid item>
                    <div className={classes.labelAndValue}>
                      <label>County:</label>
                      {override.region.county}
                    </div>
                  </Grid>
                )}

                {override.region.state && (
                  <Grid item>
                    <div className={classes.labelAndValue}>
                      <label>State:</label>
                      {override.region.state}
                    </div>
                  </Grid>
                )}

                {override.region.country && (
                  <Grid item>
                    <div className={classes.labelAndValue}>
                      <label>Country:</label>
                      {override.region.country}
                    </div>
                  </Grid>
                )}
              </Grid>
            </Grid>

            <Grid item sm={4}>
              <Grid container direction="column" spacing={1}>
                <Grid item>
                  <div className={classes.labelAndValue}>
                    <label>Created By:</label>
                    {override.createdByUsername}
                  </div>
                </Grid>
                <Grid item>
                  <div className={classes.labelAndValue}>
                    <label>Date Created:</label>
                    {override.dateCreated}
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      />
      <ListItemSecondaryAction classes={{ root: classes.actionContainer }}>
        <ConfirmButton
          handleDelete={() => onDeleteClick(override)}
          dialogTitle="Remove IP Override"
          dialogBody="Are you sure you want to remove this override?"
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default IpOverrideListItem;
